<template>
  <v-card
    class="mx-auto mb-7"
    width="95%"
  >
    <v-card-text>
      <SubTab ref="subTab"/>
      <v-form>
        <v-row v-if='getTabs.main === "additionalInfo"'>
          <requested-due-date v-if="getTabs.sub === 'rdd'" />
          <taxes v-if="getTabs.sub === 'tax_qs'" />
          <exemption-form v-if="getTabs.sub === 'usf_form'" />
          <MIAccessCharges v-if="getTabs.sub === 'mi_access_charges'"/>
          <Statetax v-if="getTabs.sub === 'statetax_form'" />
          <FederalExcise v-if="getTabs.sub === 'fed_form'" />
          <MI911 v-if="getTabs.sub === 'mi911_form'" />
          <ManageContacts v-if="getTabs.sub === 'contacts'" />
          <ApBilling v-if="getTabs.sub === 'ap_billing'" />

          <!-- AIF-81: vendors seperated out -->
          <ITVendorInfo v-if="getTabs.sub === 'vendor_info'" />
          <PBXVendorInfo v-if="getTabs.sub === 'pbx_vendor_info'" />

          <review v-if="getTabs.sub === 'review'" />
        </v-row>
        <Product v-if="getTabs.main === 'products'"/>
        <v-row class="mb-4">
          <v-divider></v-divider>
        </v-row>

        <v-row class="mb-4 pa-4">
          <v-btn
            v-if="canGoBack"
            :disabled="getGlobalLoadStatus"
            @click="handleSubNav(false)"
          >Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="canGoForward"
            :disabled="getGlobalLoadStatus"
            color="third"
            class="white--text"
            @click="handleSubNav(true)"
          >Next</v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SubTab from '@/components/tabs/SubTab.vue';
import RequestedDueDate from '@/components/cards/RequestedDueDate.vue';
import Taxes from '@/components/cards/Taxes.vue';
import ManageContacts from '@/components/cards/ManageContacts.vue';
import ApBilling from '@/components/cards/ApBilling.vue';
import ExemptionForm from '@/components/subforms/ExemptionForm.vue';
import FederalExcise from '@/components/subforms/FederalExcise.vue';
import Product from '@/components/Product.vue';
import ITVendorInfo from '@/components/cards/ITVendorInfo.vue';
import PBXVendorInfo from '@/components/cards/PBXVendorInfo.vue';
import Review from '@/components/cards/Review.vue';
import Statetax from '@/components/subforms/Statetax.vue';
import MI911 from '@/components/subforms/MI911.vue';
import MIAccessCharges from '@/components/subforms/MIAccessCharges.vue';

export default {
  name: 'SubTaskFrame',
  methods: {
    ...mapActions(['nextSubTab']),
    async handleSubNav(goRight) {
      const result = await this.nextSubTab(goRight);

      if (result?.reason) {
        this.$refs.subTab.showNotAllowedReason(result.reason);
      }
    },
  },
  components: {
    SubTab,
    RequestedDueDate,
    Taxes,
    ManageContacts,
    ApBilling,
    ExemptionForm,
    FederalExcise,
    Product,
    ITVendorInfo,
    PBXVendorInfo,
    Review,
    MIAccessCharges,
    Statetax,
    MI911,
  },
  computed: {
    ...mapGetters(['getGlobalLoadStatus', 'getTabs', 'canGoBack', 'canGoForward']),
  },
};
</script>
